import { useCallback } from 'react';

const useFormNavigation = () => {
  const handleFormKeyDown = useCallback((e) => {
    // Si c'est Enter et pas dans un textarea
    if (e.key === 'Enter' && e.target.tagName !== 'TEXTAREA') {
      e.preventDefault();
      
      // Trouver le prochain champ focusable
      const focusableElements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
      const form = e.target.form;
      const elements = Array.from(form.querySelectorAll(focusableElements));
      const index = elements.indexOf(e.target);
      
      if (index > -1) {
        const nextElement = elements[index + 1];
        if (nextElement) {
          nextElement.focus();
        }
      }
    }
  }, []);

  return {
    handleFormKeyDown
  };
};

export default useFormNavigation; 